import React from 'react'
import EPCLink from '../../../../component/Asset/EPCLink';
import TransactionItemWrongWorkflow from '../../../../transaction/component/TransactionItemWrongWorkflow';

class WrongWorkFlowGridDetailType {
  alert;

  constructor(alert) {
    this.alert = alert;
  }

  getColumns = (props, state, setState) => {
    const columns = [
      {
        Header: 'EPC',
        accessor: 'epc.value',
        Cell: row => <EPCLink epc={row.original.transactionItem.epc}/>
      },
      {
        Header: 'Referência',
        accessor: 'productType.reference',
        Cell: row => row.original.assets.productType.reference
      },
      {
        Header: 'Nome',
        accessor: 'assets.productType.friendlyName',
        Cell: row => row.original.assets.productType.friendlyName
      },
      {
        Header: 'Lote',
        accessor: 'assets.lot.code',
        Cell: row => row.original.assets.lot && row.original.assets.lot.code
      },
      {
        Header: 'Status do Fluxo',
        accessor: 'wrongWorkFlow.messages',
        style: { whiteSpace: 'unset' },
        Cell: row => <TransactionItemWrongWorkflow wrongWorkflowData={row.original.transactionItem.wrongWorkFlow}/>
      }
    ];
    return columns
  }

  endpoint = () => `alerts/v1/alerts-details/alerts/${this.alert.id}/WRONG_WORKFLOW_DETAIL`
}
export default WrongWorkFlowGridDetailType;



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/WrongWorkFlow/WrongWorkFlowGridDetailType.js